var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoCreateFolder = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14.001,
    viewBox: "0 0 18 14.001",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_CreateFolder",
    transform: "translate(-82.045 -232.336)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47562",
    "data-name": "Path 47562",
    d: "M96.178,232.336a3.805,3.805,0,1,0,3.867,3.805A3.836,3.836,0,0,0,96.178,232.336Zm.742,4.387v2.2H95.55v-2.2h-2.2V235.4h2.2v-2.034h1.37V235.4H99v1.328Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47563",
    "data-name": "Path 47563",
    d: "M96.2,240.864a4.775,4.775,0,0,1-4.808-4.73,4.586,4.586,0,0,1,.264-1.476H90.312L89,233.453a.37.37,0,0,0-.25-.092h-5.3a1.36,1.36,0,0,0-1.412,1.3v10.38a1.36,1.36,0,0,0,1.412,1.3H97.581a1.36,1.36,0,0,0,1.413-1.3v-5.072A4.822,4.822,0,0,1,96.2,240.864Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoCreateFolder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_create_folder.f209ed205e50fe21640e80eafeb8485a.svg";